module.exports = __webpack_public_path__ + "img/question.dc759427.png";